export default __webpack_public_path__ + "static/media/water_balloon.8d5f382d.mp4";